import { render, staticRenderFns } from "./MerchantOnBoardings.vue?vue&type=template&id=582d27da"
import script from "./MerchantOnBoardings.vue?vue&type=script&lang=js"
export * from "./MerchantOnBoardings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports